import { createFileRoute, useRouter } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";

import { AppointmentReceivingOptionsAdvancedConfigForm } from "@/components/appointment/appointment-receiving-options-advanced-config-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetAppointmentReceivingOptionAdvancedConfigQuery = graphql(`
  query GetAppointmentReceivingOptionAdvancedConfigQuery(
    $codUsuarioFormaRecebimento: Int!
  ) {
    formaRecebimento: usuariosFormasRecebimentos_by_pk(
      codUsuarioFormaRecebimento: $codUsuarioFormaRecebimento
    ) {
      ...AppointmentReceivingOptionsAdvancedConfigFormFragment
    }
  }
`);

const AppointmentReceivingOptionAdvancedConfigPage = (): JSX.Element => {
  const router = useRouter();
  const params = Route.useParams();

  const queryResult = useGraphQL(GetAppointmentReceivingOptionAdvancedConfigQuery, {
    codUsuarioFormaRecebimento: Number(params.appointmentReceivingOptionId),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={() => router.history.back()} />
        <HeaderTitle title="Configurações avançadas" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data && queryResult.isFetchedAfterMount ? (
            <AppointmentReceivingOptionsAdvancedConfigForm
              appointmentReceivingOption={data.formaRecebimento}
            />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config",
)({
  component: AppointmentReceivingOptionAdvancedConfigPage,
});
